import { Http } from "@Services";
import { ChartSpec } from "@Interfaces/Entities/AssistantCharts";

export interface PostAssistantMessageRequest {
    channel_id: string;
    context_channel_ids?: string[];
    message?: string;
    chat_session_id?: string;
    messages?: { role: string; text: string }[];
}

export interface PostAssistantMessageResponse {
    text?: string;
    error_message?: string;
    charts?: ChartSpec[];
}

export async function postAssistantMessage(
    payload: PostAssistantMessageRequest
): Promise<PostAssistantMessageResponse> {
    const response = await Http.Request<PostAssistantMessageResponse>({
        method: "POST",
        url: "/assistant/chat/message",
        data: payload,
    });
    return response;
}
